"use strict";
/*
 * Created on 09 10 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link PriceWithValidity}.</p>
 *
 * @author Jaroslav Sevcik
 */


var PriceWithValidityConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceWithValidityConverter, _DataObjectConverter_);

  function PriceWithValidityConverter() {
    _classCallCheck(this, PriceWithValidityConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceWithValidityConverter).apply(this, arguments));
  }

  return PriceWithValidityConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceWithValidityConverter = PriceWithValidityConverter;